/* eslint-disable react/prop-types */ // TODO: add props
import BaseLayout from './BaseLayout';
import SimpleMathKeypad from '../keypads/SimpleMath';

const SimpleMathLayout = ({
  onKeyPressCmd,
  onKeyPressWrite,
  onTriggerKeystroke,
}) => (
  <div className="keypad-layout simple-math clearfix">
    <BaseLayout {...{ onKeyPressCmd, onKeyPressWrite, onTriggerKeystroke }} />
    <SimpleMathKeypad
      onKeyPressWrite={onKeyPressWrite}
      onKeyPressCmd={onKeyPressCmd}
    />
  </div>
);

export default SimpleMathLayout;
